export default __webpack_public_path__ + "static/gourmet-4bb5ac4a708a02a6b9fe14dbb653565b.png";